import { CryptoHistoryPriceDTO, Periods } from './historyTypes'

const adapterCurrencyPriceHistory = ({
  data,
  period,
}: {
  data: CryptoHistoryPriceDTO[]
  period: Periods
}): { data: CryptoHistoryPriceDTO[] } => ({
  data: data.map((history) => {
    const date = new Date(history.date)
    const dateByLocale = date.toLocaleDateString()

    const options: Intl.DateTimeFormatOptions =
      period === 'day'
        ? { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }
        : { day: '2-digit', month: 'short', year: 'numeric' }

    const lineChartDateFormatted = date.toLocaleDateString('en-US', options)

    return {
      ...history,
      date: dateByLocale,
      lineChartDateFormatted,
    }
  }),
})

export const historyAdapter = {
  adapterCurrencyPriceHistory,
}
